module.exports = __webpack_public_path__ + "img/image2.33850d26.jpg";